module.exports = __webpack_public_path__ + "static/assets/0546f8b3fa83218a000e32a2ae9ace7b.svg";